import { render } from "./KitchenOrderItemExpansionItem.vue?vue&type=template&id=dc08401e"
import script from "./KitchenOrderItemExpansionItem.vue?vue&type=script&lang=js"
export * from "./KitchenOrderItemExpansionItem.vue?vue&type=script&lang=js"

import "./KitchenOrderItemExpansionItem.vue?vue&type=style&index=0&id=dc08401e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSlideItem from 'quasar/src/components/slide-item/QSlideItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSlideItem,QIcon,QExpansionItem,QBtn});
